// extracted by mini-css-extract-plugin
export default {"block":"blocks_block__3Aocu","block-wrap-accordion":"blocks_block-wrap-accordion__15TaK"};